// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__account-select-dialog',
    // #endregion
    data: () => ({
        isLoading: false,
        accounts: [],
        filterText: '',
    }),
    computed: {
        currentWindow() {
            return this.$utils.findVueComponent(this, ["g-modal-popup", "g-modal-slide"]);
        },
        accountID() {
            return this.$appHost.store.get("session").currentUser?.accountID;
        },
        filteredAccounts() {
            const q = this.filterText.trim().toLowerCase();
            if (!q)
                return this.accounts;
            return this.accounts.filter(a => a.displayName?.toLowerCase().includes(q) ||
                a.konto?.toLowerCase().includes(q) ||
                a.address?.name1?.toLowerCase().includes(q) ||
                a.address?.name2?.toLowerCase().includes(q) ||
                a.address?.city?.toLowerCase().includes(q) ||
                a.address?.zipCode?.toLowerCase().includes(q));
        },
    },
    beforeMount() {
        this.loadData();
    },
    // #region Core
    methods: {
        async loadData() {
            this.isLoading = true;
            try {
                this.accounts = (await appHost.api.get('identity/accounts')).data;
            }
            catch {
                this.accounts = [];
            }
            this.isLoading = false;
        },
        async onSelect(account) {
            if (!account) {
                return;
            }
            //Set
            await this.$appHost.login.setAccount(account.accountID);
            //Close
            this.currentWindow.close();
        },
        onGotoAccount() {
            //Move
            this.$router.push('/service/accounts');
            //Close
            this.currentWindow.close();
        },
    },
    // #endregion
});
// #endregion
